export interface INewBody {
  name: string;
  mappingType: string;
  fields: {
    fieldToParse: string;
    field: string;
  }[];
}

interface data {
  name: string;
  numberCargo: string;
  orderCode: string;
  address: string;
  address2: string;
  weight: string;
  corporateName: string;
  nf: string;
  price: string;
  latitude: string;
  longitude: string;
  cep: string;
  mappingType: string;
  fantasyName?: string;
  weightUnity: string;
}
function reorderBodyMapping(data: data) {
  const newBody: INewBody = {
    name: '',
    mappingType: '',
    fields: [
      {
        fieldToParse: '',
        field: '',
      },
    ],
  };

  newBody.name = data.name;
  newBody.mappingType = data.mappingType;
  newBody.fields = [
    {
      fieldToParse: data.numberCargo,
      field: 'numberCargo',
    },

    {
      fieldToParse: data.orderCode,
      field: 'orderCode',
    },

    {
      fieldToParse: data.address,
      field: 'address',
    },

    {
      fieldToParse: data.address2,
      field: 'address2',
    },

    {
      fieldToParse: data.weight,
      field: 'weight',
    },

    {
      fieldToParse: data.corporateName,
      field: 'corporateName',
    },

    {
      fieldToParse: data.fantasyName ?? data.corporateName,
      field: 'fantasyName',
    },
    {
      fieldToParse: data.nf,
      field: 'nf',
    },

    {
      fieldToParse: data.price,
      field: 'price',
    },

    {
      fieldToParse: data.latitude,
      field: 'latitude',
    },

    {
      fieldToParse: data.longitude,
      field: 'longitude',
    },

    {
      fieldToParse: data.cep,
      field: 'cep',
    },

    {
      fieldToParse: data.weightUnity,
      field: 'weightUnity',
    },
  ];

  return newBody;
}

export default reorderBodyMapping;
